import { useState, useEffect } from 'react';
import { Marker, MarkerPopup } from 'hcmaps-leaflet';
import { useSelector, useDispatch } from 'react-redux';
import classNames from 'classnames';
import { propertyStatusIndicatorBuilder } from 'legacy/utils/maps';
import {
  COMP_TYPE_RENTAL,
  ID_PORTAL_LAYER_CONTROLS,
  MAP_CONTROL_TYPE_HEATMAP
} from 'legacy/appstore/constants';
import { getPropertyMarkerLabel } from 'legacy/utils/property-details';
import LocationUnknownWarningContainer from 'legacy/containers/location-unknown-warning';
import { abbrShortDollarsFormatter } from 'legacy/utils/formatters';
import PropertyCardContainer from 'legacy/containers/property-card';
import HeatmapControlPanel from 'legacy/components/HeatmapControlPanel';
import Maps from 'legacy/containers/maps';
import { getCompsSelectedIds } from 'selectors/comps-context';
import { useFeatureFlags } from 'legacy/hocs/useFeatureFlags';
import { CompsMap as theme } from 'legacy/css-modules';
import { compsShowOnMapClear } from '../appstore/actions/comps.actions';
import { rentalCompsShowOnMapClear } from '../appstore/actions/rental-comps.actions';

const PULSE_IMG =
  'data:image/png;base64,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';
const PULSE_HTML = `<img class='map-marker-pulse' src='${PULSE_IMG}' />`;

const HoveredPin = ({ hoveredPin, compType }) => {
  const dispatch = useDispatch();
  const selectedIds = useSelector(getCompsSelectedIds);
  const isSelectedPin = selectedIds.indexOf(hoveredPin.comp.addressId) > -1;
  const closeCallback = () => {
    dispatch(
      compType === COMP_TYPE_RENTAL
        ? rentalCompsShowOnMapClear()
        : compsShowOnMapClear()
    );
  };
  useEffect(() => {
    window.addEventListener('click', closeCallback);
    return () => {
      window.removeEventListener('click', closeCallback);
    };
  }, []);
  return (
    <Marker
      onClick={(m, e) => {
        // Stop propagation so the window close callback isn't called
        e.originalEvent.stopPropagation();
      }}
      key={`hovered-comp-${hoveredPin.comp.addressId}`}
      position={[
        hoveredPin.comp.geoLocation.latitude,
        hoveredPin.comp.geoLocation.longitude
      ]}
      leafletOptions={{
        zIndexOffset: 100000000,
        riseOnHover: true,
        riseOffset: 1001
      }}
      iconConfig={{
        html: `<div class='map-marker-icon' data-hc-name='comp-pin-hovered'></div>${PULSE_HTML}`,
        className: classNames('map-marker-wrapper', {
          'map-marker-wrapper--selected':
            selectedIds.indexOf(hoveredPin.comp.addressId) > -1
        }),
        iconAnchor: [15, 40],
        popupAnchor: [0, -52]
      }}
      /* eslint-disable xss/no-mixed-html */
      labelForHtmlIcon={propertyStatusIndicatorBuilder(
        false,
        hoveredPin.comp.propertyStatus,
        abbrShortDollarsFormatter(getPropertyMarkerLabel(hoveredPin.comp)),
        hoveredPin.comp.propertyStatusRental,
        isSelectedPin
      )}
      /* eslint-enable xss/no-mixed-html */
      excludeFromCluster
      Popup={
        hoveredPin.pinOnly ? undefined : (
          <MarkerPopup
            className="map-marker-popup--hovered-comp"
            leafletOptions={{
              closeButton: true,
              autoPan: false
            }}
            autoOpen
          >
            <PropertyCardContainer
              addressId={hoveredPin.comp.addressId}
              compType={compType}
              isSubject={false}
              layout="horizontal"
              hideSelectControl={false}
              hideSimilarity={false}
              noOnClick={false}
            />
          </MarkerPopup>
        )
      }
    />
  );
};

const CompsMap = (props) => {
  useFeatureFlags();
  const {
    compType,
    markers,
    farmUpdatedAt,
    mapId,
    dataHcNames,
    locationUnknownPosition,
    hoveredPin
  } = props;
  const [farmLastUpdated, setFarmLastUpdated] = useState(null);
  const fitMarkersOnMarkerChange =
    markers.length < 2 || farmUpdatedAt !== farmLastUpdated;
  useEffect(() => {
    setFarmLastUpdated(farmUpdatedAt);
  }, [farmUpdatedAt]);
  return (
    <div data-hc-name="comps-selection-map-section" className={theme.CompsMap}>
      <div className={theme.Map}>
        {!!markers.length && (
          <Maps
            dataHcName={dataHcNames.map}
            fitMarkersOnMarkerChange={fitMarkersOnMarkerChange}
            LayersControlWrapper={(props) => <HeatmapControlPanel {...props} />}
            qaSelectorSuffix={
              compType === COMP_TYPE_RENTAL ? '-rental-comps' : '-comps'
            }
            {...props}
          >
            {!!hoveredPin && hoveredPin.comp && (
              <HoveredPin
                key={hoveredPin.comp.addressId}
                hoveredPin={hoveredPin}
                compType={compType}
              />
            )}
          </Maps>
        )}
        <LocationUnknownWarningContainer
          mapId={mapId}
          compType={compType}
          position={locationUnknownPosition}
        />
      </div>
      <div
        id={ID_PORTAL_LAYER_CONTROLS}
        className={classNames(theme.Controls, {
          [theme.controlsVisible]:
            props.visibleControlsType === MAP_CONTROL_TYPE_HEATMAP
        })}
      />
    </div>
  );
};
export default CompsMap;
